import { ActiveEventFlat } from '@/modules/results/types';

export const OVERALL = 'overall';

export enum MatchupStatusEnum {
  SCHEDULED_MATCHUP_STATUS = 'SCHEDULED_MATCHUP_STATUS',
  IN_PROGRESS_MATCHUP_STATUS = 'IN_PROGRESS_MATCHUP_STATUS',
  DELAYED_MATCHUP_STATUS = 'DELAYED_MATCHUP_STATUS',
  COMPLETED_MATCHUP_STATUS = 'COMPLETED_MATCHUP_STATUS',
  SCHEDULED_WAITING_FOR_AWAY_TEAM_LINEUP = 'SCHEDULED_WAITING_FOR_AWAY_TEAM_LINEUP',
  SCHEDULED_WAITING_FOR_HOME_TEAM_LINEUP = 'SCHEDULED_WAITING_FOR_HOME_TEAM_LINEUP',
  READY_TO_BE_STARTED_STATUS = 'READY_TO_BE_STARTED_STATUS',
}

export const MatchupStatusApiMap: Record<MatchupStatusEnum, number> = {
  [MatchupStatusEnum.SCHEDULED_MATCHUP_STATUS]: 1,
  [MatchupStatusEnum.IN_PROGRESS_MATCHUP_STATUS]: 2,
  [MatchupStatusEnum.DELAYED_MATCHUP_STATUS]: 3,
  [MatchupStatusEnum.COMPLETED_MATCHUP_STATUS]: 4,
  [MatchupStatusEnum.SCHEDULED_WAITING_FOR_AWAY_TEAM_LINEUP]: 6,
  [MatchupStatusEnum.SCHEDULED_WAITING_FOR_HOME_TEAM_LINEUP]: 7,
  [MatchupStatusEnum.READY_TO_BE_STARTED_STATUS]: 8,
};

export const getMatchupStatusApiValue = (status: MatchupStatusEnum): number => {
  return MatchupStatusApiMap[status];
};

export enum MatchupCompletedEnum {
  UNDEFINED_MATCHUP_COMPLETION_TYPE = 'UNDEFINED_MATCHUP_COMPLETION_TYPE',
  PLAYED_MATCHUP_COMPLETION_TYPE = 'PLAYED_MATCHUP_COMPLETION_TYPE',
  HOME_TEAM_WITHDRAW_MATCHUP_COMPLETION_TYPE = 'HOME_TEAM_WITHDRAW_MATCHUP_COMPLETION_TYPE',
  AWAY_TEAM_WITHDRAW_MATCHUP_COMPLETION_TYPE = 'AWAY_TEAM_WITHDRAW_MATCHUP_COMPLETION_TYPE',
  CANCELED_MATCHUP_COMPLETION_TYPE = 'CANCELED_MATCHUP_COMPLETION_TYPE',
}

export const statusText: Record<MatchupStatusEnum, string> = {
  [MatchupStatusEnum.SCHEDULED_MATCHUP_STATUS]: 'starting soon',
  [MatchupStatusEnum.SCHEDULED_WAITING_FOR_HOME_TEAM_LINEUP]: 'starting soon',
  [MatchupStatusEnum.SCHEDULED_WAITING_FOR_AWAY_TEAM_LINEUP]: 'starting soon',
  [MatchupStatusEnum.IN_PROGRESS_MATCHUP_STATUS]: 'in progress',
  [MatchupStatusEnum.COMPLETED_MATCHUP_STATUS]: 'completed',
  [MatchupStatusEnum.DELAYED_MATCHUP_STATUS]: 'delayed',
  [MatchupStatusEnum.READY_TO_BE_STARTED_STATUS]: 'ready to be played',
};

export enum MatchupCompletedEnumTypes {
  UNDEFINED_MATCHUP_COMPLETION_TYPE = 0,
  PLAYED_MATCHUP_COMPLETION_TYPE = 1,
  HOME_TEAM_WITHDRAW_MATCHUP_COMPLETION_TYPE = 2,
  AWAY_TEAM_WITHDRAW_MATCHUP_COMPLETION_TYPE = 3,
  CANCELED_MATCHUP_COMPLETION_TYPE = 4,
}

// ---------- Match Status ----------
export enum MatchStatusEnum {
  UNDEFINED_MATCH_STATUS = 'UNDEFINED_MATCH_STATUS',
  SCHEDULED_MATCH_STATUS = 'SCHEDULED_MATCH_STATUS',
  IN_PROGRESS_MATCH_STATUS = 'IN_PROGRESS_MATCH_STATUS',
  DELAYED_MATCH_STATUS = 'DELAYED_MATCH_STATUS',
  COMPLETED_MATCH_STATUS = 'COMPLETED_MATCH_STATUS',
  COMPLETED_BUT_WAITING_FOR_SCORE_CONFIRMATION_STATUS = 'COMPLETED_BUT_WAITING_FOR_SCORE_CONFIRMATION_STATUS',
  COMPLETED_BUT_DISPUTED_STATUS = 'COMPLETED_BUT_DISPUTED_STATUS',
  BYE_MATCH_STATUS = 'BYE_MATCH_STATUS',
}

export const MatchStatusApiMap: Record<MatchStatusEnum, number> = {
  [MatchStatusEnum.UNDEFINED_MATCH_STATUS]: 0,
  [MatchStatusEnum.SCHEDULED_MATCH_STATUS]: 1,
  [MatchStatusEnum.IN_PROGRESS_MATCH_STATUS]: 2,
  [MatchStatusEnum.DELAYED_MATCH_STATUS]: 3,
  [MatchStatusEnum.COMPLETED_MATCH_STATUS]: 4,
  [MatchStatusEnum.COMPLETED_BUT_WAITING_FOR_SCORE_CONFIRMATION_STATUS]: 5,
  [MatchStatusEnum.COMPLETED_BUT_DISPUTED_STATUS]: 6,
  [MatchStatusEnum.BYE_MATCH_STATUS]: 7,
} as const;

export const getMatchStatusApiValue = (status: MatchStatusEnum): number => {
  return MatchStatusApiMap[status];
};

export enum MatchCompletedEnum {
  UNDEFINED_MATCH_COMPLETION_TYPE = 0,
  MATCH_NOT_COMPLETED_TYPE = 1,
  FORFEIT_MATCH_COMPLETED_TYPE = 2,
  RETIREMENT_MATCH_COMPLETED_TYPE = 3,
  WITHDRAWAL_MATCH_COMPLETED_TYPE = 4,
  PLAYED_MATCH_COMPLETED_TYPE = 5,
  CANCELED_MATCH_COMPLETED_TYPE = 6,
  WONT_BE_PLAYED_MATCH_COMPLETED_TYPE = 14,
}

// ---------- Game Status ----------
export enum GameCompletedEnum {
  UNDEFINED_GAME_COMPLETION_TYPE = 0,
  GAME_NOT_COMPLETED_TYPE = 1,
  FORFEIT_TEAM_ONE_GAME_COMPLETED_TYPE = 2,
  RETIREMENT_TEAM_ONE_GAME_COMPLETED_TYPE = 3,
  WITHDRAWAL_TEAM_ONE_GAME_COMPLETED_TYPE = 4,
  PLAYED_COMPLETED_TYPE = 5,
  CANCELED_GAME_COMPLETED_TYPE = 6,
  FORFEIT_TEAM_TWO_GAME_COMPLETED_TYPE = 7,
  RETIREMENT_TEAM_TWO_GAME_COMPLETED_TYPE = 8,
  WITHDRAWAL_TEAM_TWO_GAME_COMPLETED_TYPE = 9,
  DID_NOT_PLAYED_COMPLETED_TYPE = 10,
}

export const TEAM_LEAGUES_MODULE = 120;

export enum SequenceStatus {
  NOT_PLAYED = 'NOT_PLAYED_TIEBREAKER_SEQUENCE_STATUS',
  PLAYED = 'PLAYED_TIEBREAKER_SEQUENCE_STATUS',
  IN_PROGRESS = 'IN_PROGRESS_TIEBREAKER_SEQUENCE_STATUS',
}

export enum ScoreCardType {
  TOTAL = 'Total team score',
  PLAYING = 'Playing now',
  PLAYED = 'Already played',
  NEXT = 'Next In',
}

export const TEAM_EVENTS: ActiveEventFlat = {
  group_title: 'Team Events',
  bracket_level_id: 0,
  format_id: 0,
  player_group_id: 0,
  display_order: -1,
};
